import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ChangeOrderStatusHook from "../../hook/admin/ChangeOrderStatusHook";
import GetOrderDetailsHook from "../../hook/admin/GetOrderDetailsHook";
import UserAllOrderItem from "../User/UserAllOrderItem";
import { ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import LoadingBar from "react-top-loading-bar";
import LoadingSpinner from "../Utilities/LoadingSpinner";

const AdminOrderDetails = () => {
  const { id } = useParams();
  const [orderData, cartItems, settingsRes, ref, setLoading, loading] = GetOrderDetailsHook(id);
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const [
    onChangePaid, changePayOrder, onChangeDelivered, changeDeliveredOrder,
    orderStatusRes, delivered, pay, show, handleClose, handleShow,
    description, onChangeDescription, showModalDescription, allOrderHistory,
    handleCloseModel, refundValue, onChangeRefundValue,
    onChangeRefundDescription, refundDescription,
  ] = ChangeOrderStatusHook(id, orderData?.user?._id);

  const columns = [
    { name: t("Serial"), selector: "index", sortable: true },
    { name: t("payment state"), selector: (row) => row.paymentStatus == "true" ? t("Paid") : t("not paid"), sortable: true },
    { name: t("order state"), selector: "orderStatus", sortable: true },
    { name: t("the user"), selector: (row) => row.user?.firstname + " " + row.user?.lastname, sortable: true },
    { name: t("date"), selector: (row) => formatDate(row.createdAt), sortable: true },
    { name: t("Notes"), selector: "desc", sortable: true },
  ];

  const tableData = { columns, data: allOrderHistory.data };

  return (
    <div className="order-details-page">
      <Helmet>
        <title>{`${t("Order Details No.")} ${orderData?.orderNumber || ""} - ${Cookies.get("i18next") === "ar" ? settingsRes?.data?.titleAr : settingsRes?.data?.titleEn}`}</title>
      </Helmet>

      {loading && <LoadingSpinner />}

      {/* Modal */}
      <Modal show={show} onHide={handleCloseModel}>
        <Modal.Header><Modal.Title><div className="font">{t("Do you want to add notes")}</div></Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="font">
            <textarea id="description" onChange={onChangeDescription} value={description} className="input-form-area p-2 mt-2" rows="4" cols="50" placeholder={t("add notes")} />
          </div>
          <Row className="justify-content-start">
            {delivered === "63c7c73b643a9581a2d252ec" ? (
              <Col sm="12">
                <label htmlFor="refundValue" className="d-block mt-2">{t("refundValue")}</label>
                <input id="refundValue" value={refundValue} onChange={onChangeRefundValue} type="number" className="input-form d-block mt-2 px-3" placeholder={t("refundValue")} />
                <label htmlFor="refundDescription" className="d-block mt-2">{t("refundDescription")}</label>
                <textarea id="refundDescription" onChange={onChangeRefundDescription} value={refundDescription} className="input-form-area p-2 mt-2" rows="4" cols="50" placeholder={t("refundDescription")} />
              </Col>
            ) : null}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="font" onClick={() => handleClose()}>{t("Save Changes")}</Button>
        </Modal.Footer>
      </Modal>

      <LoadingBar color={settingsRes?.data?.primaryColor} ref={ref} shadow={true} height={4} />

      {/* Page Header */}
      <div className="od-header">
        <div>
          <h4 className="od-title">{`${t("Order Details No.")} #${orderData?.orderNumber || ""}`}</h4>
          <span className="od-date">{orderData?.createdAt ? formatDate(orderData.createdAt) : ""}</span>
        </div>
        <div className="od-header-badges">
          <span className={`od-badge ${orderData?.isPaid ? "od-badge-success" : "od-badge-danger"}`}>
            <i className={`fa-solid ${orderData?.isPaid ? "fa-check-circle" : "fa-times-circle"} me-1`}></i>
            {orderData?.isPaid ? t("paid") : t("not paid")}
          </span>
          <span className="od-badge od-badge-info">
            {orderData?.orderStatusId?.nameAr || t("order state")}
          </span>
        </div>
      </div>

      {/* Row 1: Customer + Address + Quick Actions */}
      <Row className="g-3 mb-3">
        <Col md={4}>
          <div className="od-card">
            <div className="od-card-header">
              <i className="fa-solid fa-user"></i> {t("Customer Details")}
            </div>
            <div className="od-card-body">
              <div className="od-info"><span className="od-info-label">{t("name")}</span><span className="od-info-val">{`${orderData?.user?.firstname || ""} ${orderData?.user?.lastname || ""}`}</span></div>
              <div className="od-info"><span className="od-info-label">{t("phone number")}</span><span className="od-info-val">{orderData?.user?.mobile || ""}</span></div>
              <div className="od-info"><span className="od-info-label">{t("email")}</span><span className="od-info-val">{orderData?.user?.email || ""}</span></div>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="od-card">
            <div className="od-card-header">
              <i className="fa-solid fa-location-dot"></i> {t("Client's Address")}
            </div>
            <div className="od-card-body">
              <div className="od-info"><span className="od-info-label">{t("address name")}</span><span className="od-info-val">{orderData?.userAddress?.address || "—"}</span></div>
              {settingsRes?.data?.showAddressDetails && (
                <>
                  <div className="od-info"><span className="od-info-label">{t("nearest mark")}</span><span className="od-info-val">{orderData?.userAddress?.closeSign || "—"}</span></div>
                  <div className="od-info"><span className="od-info-label">{t("zone")}</span><span className="od-info-val">{orderData?.userAddress?.zone || "—"}</span></div>
                  <div className="od-info"><span className="od-info-label">{t("phone number")}</span><span className="od-info-val">{orderData?.userAddress?.mobile || "—"}</span></div>
                </>
              )}
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${orderData?.userAddress?.latitude},${orderData?.userAddress?.longitude}`}
                target="_blank" rel="noreferrer" className="od-map-link"
              >
                <i className="fa-solid fa-map-location-dot me-1"></i> {t("Client address link")}
              </a>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="od-card">
            <div className="od-card-header">
              <i className="fa-solid fa-sliders"></i> {t("payment state")} & {t("order state")}
            </div>
            <div className="od-card-body">
              <div className="od-action-group">
                <label className="od-action-label">{t("payment state")}</label>
                <select className="od-select" onChange={onChangePaid} value={pay}>
                  <option value="true">{t("paid")}</option>
                  <option value="false">{t("not paid")}</option>
                </select>
                <button onClick={() => showModalDescription(1)} className="od-save-btn" style={{ backgroundColor: settingsRes?.data?.primaryColor || "#0d6efd" }}>
                  <i className="fa-solid fa-floppy-disk me-1"></i> {t("save")}
                </button>
              </div>
              <div className="od-action-divider"></div>
              <div className="od-action-group">
                <label className="od-action-label">{t("order state")}</label>
                <select className="od-select" onChange={onChangeDelivered} value={delivered}>
                  {orderStatusRes?.data?.map((el) => (
                    <option key={el._id} value={el._id}>
                      {Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
                    </option>
                  ))}
                </select>
                <button onClick={() => showModalDescription(2)} className="od-save-btn" style={{ backgroundColor: settingsRes?.data?.primaryColor || "#0d6efd" }}>
                  <i className="fa-solid fa-floppy-disk me-1"></i> {t("save")}
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Row 2: Order Items */}
      <div className="od-card mb-3">
        <div className="od-card-header">
          <i className="fa-solid fa-box-open"></i> منتجات الطلب
        </div>
        <div className="od-card-body">
          <UserAllOrderItem orderItem={orderData} setLoading={setLoading} loading={loading} />
        </div>
      </div>

      {/* Row 3: Refund Reason */}
      {orderData?.reasonRefund && (
        <div className="od-card mb-3 od-card-warning">
          <div className="od-card-header" style={{ color: "#c53030" }}>
            <i className="fa-solid fa-rotate-left"></i> {t("Client's Resson for refund")}
          </div>
          <div className="od-card-body">
            <div className="od-info"><span className="od-info-label">{t("reason")}</span><span className="od-info-val">{orderData?.reasonRefund || ""}</span></div>
          </div>
        </div>
      )}

      {/* Row 4: Order History */}
      <div className="od-card">
        <div className="od-card-header">
          <i className="fa-solid fa-clock-rotate-left"></i> {t("Summary of order states")}
        </div>
        <div style={{ padding: 0 }}>
          <DataTableExtensions {...tableData} filterPlaceholder={t("save")}>
            <DataTable noHeader defaultSortAsc={false} pagination highlightOnHover />
          </DataTableExtensions>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default AdminOrderDetails;
